import React from 'react';
import { useNetworkElementsStore } from '../store/networkElementsStore';

export function StatusOverlay() {
  const hasError = useNetworkElementsStore(state => state.hasError);
  const errorMessage = useNetworkElementsStore(state => state.errorMessage);
  const [showError, setShowError] = React.useState(true);

  // Reset showError when a new error occurs. If the error remains the same after dismissal,
  // the overlay stays hidden to avoid blocking the UI.
  const prevErrorRef = React.useRef(errorMessage);
  React.useEffect(() => {
    if (prevErrorRef.current !== errorMessage) {
      setShowError(true);
      prevErrorRef.current = errorMessage;
    }
  }, [errorMessage]);

  // Only render if there's an error to show
  if (!hasError || !showError) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50 space-y-4">
      {/* Error Message */}
      <div className="bg-error-100 dark:bg-error-900/40 border border-error-400 dark:border-error-600 text-error-800 dark:text-error-200 px-4 py-3 rounded-lg shadow-lg max-w-md">
        <div className="flex justify-between items-start">
          <div className="flex items-center">
            <svg className="w-4 h-4 mr-2 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="12" cy="12" r="10" strokeWidth="2"/>
              <path d="M12 8v4m0 4h.01" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <span>{errorMessage}</span>
          </div>
          <button
            onClick={() => setShowError(false)}
            className="ml-4 text-error-800 dark:text-error-200 hover:text-error-900 dark:hover:text-error-100"
            aria-label="Schließen"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
